import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoModule, provideTranslocoScope } from '@jsverse/transloco';

interface CatalogItem {
  id: string;
  image: string;
  title: string;
  subtitle: string;
}

@Component({
  selector: 'mzic-artist-catalog',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './artist-catalog.component.html',
  styleUrls: ['./artist-catalog.component.scss'],
  providers: [
    provideTranslocoScope({
      scope: 'investor-landing',
      alias: 'lang',
    }),
  ],
})
export class ArtistCatalogComponent {
  @Input() artistImage = '';
  @Input() artistImageLink = '';
  @Input() artistName = '';
  @Input() items: CatalogItem[] = [];
  @Input() displayMode: 'catalog' | 'image' = 'catalog';
  @Input() title = '';
  @Input() description = '';
}
